import React from 'react'
import { Link } from 'react-router'

import {
  DataCard,
  Title,
  Details,
  Dot,
  TimeFrame,
  Message
} from '../data-card/data-card-parts'

import IssueCardOptionsContainer from '../../containers/issues/issue-card-options-container'

class IssueCard extends React.Component {
  render () {
    const { issueId, locationId, area, issueDescription, issue, submittedBy } = this.props

    let date
    if (issue.status === 'resolved') {
      date = issue.resolvedAt.format('MMMM D, YYYY [at] h:mm A')
    } else {
      date = issue.submittedAt.format('MMMM D, YYYY [at] h:mm A')
    }

    let submittedByName = ""

    if (submittedBy) { // For some reason this was null at some point
      submittedByName = submittedBy.name
    }

    return (
      <DataCard>
        <IssueCardOptionsContainer issueId={issueId} locationId={issue.location}/>
        <Link to={`location-issues/${issue.location}/issue/${issueId}`} >
          <Details>
            <Title text={area.name} />
            <Dot />
            <TimeFrame text={date} />
          </Details>
          <Message
            key={this.props.issueId}
            text={`Submitted by ${submittedByName}`}
          />
          <Message text={issueDescription.name} />
        </Link>
      </DataCard>
    )
  }
}

export default IssueCard



// WEBPACK FOOTER //
// ./src/components/issues/issue-card.js